import { initState, types } from "./types";

const jobsReducer = (state = initState, action) => {
  switch (action.type) {
    case types.GET_ALL_JOBS:
      return {
        ...state,
        // Keep list visible during background/page merges (soft remount + scroll).
        isLoading: state.jobs.length === 0,
        isFetching: true,
        error: ""
      };
    case types.GET_ALL_JOBS_SUCCESS: {
      // A background list refresh can be in flight from before a clap/comment
      // landed, so `action.jobs` here may be a stale, react-less snapshot.
      // `_.merge` deep-merges nested arrays *by index*, so blending a stale
      // `reacts`/`comments` array with a fresh one produced a corrupted
      // Frankenstein array — visible as the clap button flickering back to
      // unclapped once this stale response landed. reacts/comments are kept
      // current by the dedicated per-job fetch and sockets, so here we just
      // keep whichever side has more of them instead of deep-merging.
      const incomingById = {};
      action.jobs.forEach((job) => { incomingById[job._id] = job; });

      const reconcile = (existing, incoming) => {
        if (!incoming) return existing;
        if (!existing) return incoming;
        const reacts = (existing.reacts?.length || 0) >= (incoming.reacts?.length || 0)
          ? existing.reacts : incoming.reacts;
        const comments = (existing.comments?.length || 0) >= (incoming.comments?.length || 0)
          ? existing.comments : incoming.comments;
        return { ...incoming, reacts, comments };
      };

      const seenIds = new Set();
      const merged = state.jobs.map((existing) => {
        seenIds.add(existing._id);
        return reconcile(existing, incomingById[existing._id]);
      });
      const appended = action.jobs.filter((job) => !seenIds.has(job._id));

      return {
        ...state,
        jobs: [...merged, ...appended],
        hasMore: action.hasMore,
        currentPage: action.currentPage,
        isLoading: false,
        isFetching: false,
      };
    }
    case types.GET_ALL_JOBS_FAILED:
      return {
        ...state,
        isLoading: false,
        isFetching: false,
        error: action.message
      };
    case types.GET_A_JOB:
      return {
        ...state,
        error: ""
      };
    case types.GET_A_JOB_SUCCESS: {
      const { filterUserId } = action;
      if (
        filterUserId &&
        action.job?.userId &&
        String(action.job.userId) !== String(filterUserId)
      ) {
        return state;
      }

      const existingIdx = state.jobs.findIndex(
        (item) => item._id === action.jobId || item._id === action.job?._id
      );
      if (existingIdx >= 0) {
        return {
          ...state,
          jobs: state.jobs.map((item, idx) =>
            idx === existingIdx ? action.job : item
          ),
        };
      }
      // Socket / single-fetch upsert: prepend; FeedPage still sorts by extRefDate.
      return {
        ...state,
        jobs: [action.job, ...state.jobs],
      };
    }
    case types.GET_A_JOB_FAILED:
      return {
        ...state,
        error: action.message
      };
    case types.RESET_JOBS:
      return {
        ...state,
        jobs: [],
        hasMore: false,
        currentPage: 1,
        isFetching: false,
      };
    case types.ADD_COMMENT:
      return {
        ...state,
        jobs: state.jobs.map(job => job._id === action.jobId ? {
          ...job,
          comments: [...job.comments, action.comment]
        } : job)
      };
    default:
      return state;
  }
};

export default jobsReducer;
